<template>
    <sui-form @submit="onSubmit">
        <ProxySelector :proxy="activeGateway.configuration.proxyCode" />

        <sui-divider section />

        <GlobalConfig fetchMethod="PROXY" />

        <MediaConfig fetchMethod="PROXY" />

        <CronConfig />

        <sui-button color="violet" fluid>{{ $t('common.save') }}</sui-button>
    </sui-form>
</template>

<script>
    import GlobalConfig from '@/components/gateway/fields/GlobalConfig';
    import CronConfig from '@/components/gateway/fields/CronConfig';
    import ProxySelector from '@/components/gateway/fields/ProxySelector';
    import MediaConfig from '@/components/gateway/fields/MediaConfig';
    import store from '@/store';
    import { mapGetters } from 'vuex';

    export default {
        name: 'ProxyForm',
        components: {
            GlobalConfig,
            CronConfig,
            MediaConfig,
            ProxySelector: ProxySelector,
        },
        props: {
            onSubmit: Function,
        },
        computed: {
            ...mapGetters(['activeGateway']),
            isMediaInputURLDisabled: {
                get() {
                    return this.activeGateway.configuration.urlConfiguration.hasMediaURL === false;
                },
            },
            state: {
                get() { return store.state; }
            },
        },
        methods: {
            onInputFocus(e) {
                this.state.forms.gateway.currentSelectedInput = e.target;
            },
        },
    }
</script>
